import {
  REQUEST_CENSUSES,
  RECEIVE_CENSUSES,
  CLEAR_CENSUSES,
  REQUEST_AUDIENCE_CENSUSES,
  RECEIVE_AUDIENCE_CENSUSES,
  RECEIVE_CENSUS_ERROR
} from '../../actions/CarrierVerification/consts'

const defaultState = {
  censuses: undefined,
  getInProgress: false,
  censusesByAudience: {}
}

export default function CensusReducer(state = defaultState, action) {
  switch (action.type) {
  case CLEAR_CENSUSES:
    return { ...state,
      censuses: undefined,
      censusesByAudience: {} }
  case REQUEST_CENSUSES:
    return { ...state,
      getInProgress: true,
      censuses: undefined }
  case REQUEST_AUDIENCE_CENSUSES:
    return { ...state, getInProgress: true }
  case RECEIVE_CENSUSES:
    return { ...state,
      getInProgress: false,
      censuses: action.censuses }
  case RECEIVE_AUDIENCE_CENSUSES: {
    const censusesByAudience = state.censusesByAudience
    censusesByAudience[action.audience] = action.censuses

    return { ...state,
      getInProgress: false,
      censusesByAudience }
  }
  // A failed getAllAudienceCensuses left getInProgress true forever. Clears only the
  // flag -- censusesByAudience is untouched, so a sibling audience's loaded list survives.
  case RECEIVE_CENSUS_ERROR:
    return { ...state, getInProgress: false }
  default:
    return { ...state }
  }
}
